import { Link, NavLink, Outlet } from "react-router-dom";

interface NavItem {
  to: string;
  label: string;
  icon: string;
  end?: boolean;
}
const items: NavItem[] = [
  { to: "/admin", label: "ダッシュボード", icon: "🏠", end: true },
  { to: "/admin/members", label: "会員管理", icon: "👥" },
  { to: "/admin/events", label: "イベント管理", icon: "🗓" },
  { to: "/admin/checkin", label: "受付", icon: "📷" },
  { to: "/admin/contents", label: "コンテンツ", icon: "🎥" },
  { to: "/admin/notices", label: "お知らせ", icon: "📢" },
  { to: "/admin/perks", label: "会員特典", icon: "🎁" },
  { to: "/admin/hearings", label: "ヒアリング", icon: "📝" },
  { to: "/admin/audit-logs", label: "監査ログ", icon: "📋" },
  { to: "/admin/myasp-logs", label: "決済ログ", icon: "💳" },
];

export function AdminLayout() {
  return (
    <div className="min-h-screen flex flex-col bg-tora-paper">
      <header
        className="bg-tora-ink text-white border-b-2 border-tora"
        style={{ paddingTop: "env(safe-area-inset-top)" }}
      >
        <div className="mx-auto max-w-6xl px-4 py-3 flex items-center gap-3">
          <Link
            to="/admin"
            className="font-bold text-white text-base md:text-lg tracking-wide"
          >
            令和の虎 経営塾
            <span className="ml-2 text-xs text-tora font-semibold align-middle">
              管理画面
            </span>
          </Link>
          <Link
            to="/"
            className="ml-auto text-sm text-white/70 hover:text-white transition-colors"
          >
            ← 会員サイトへ戻る
          </Link>
        </div>
      </header>
      <div className="flex-1 mx-auto w-full max-w-6xl px-4 py-6 md:py-10 grid grid-cols-12 gap-6 md:gap-8">
        <aside className="col-span-12 md:col-span-3">
          <nav className="flex md:flex-col gap-1 overflow-x-auto md:overflow-visible -mx-4 md:mx-0 px-4 md:px-0">
            {items.map((i) => (
              <NavLink
                key={i.to}
                to={i.to}
                end={i.end}
                className={({ isActive }) =>
                  `whitespace-nowrap rounded-lg px-3 py-2.5 text-sm flex items-center gap-2 transition-colors ${
                    isActive
                      ? "bg-tora text-white font-semibold shadow-sm"
                      : "text-tora-ink/80 hover:bg-tora/5 hover:text-tora"
                  }`
                }
              >
                <span className="text-base" aria-hidden="true">
                  {i.icon}
                </span>
                <span>{i.label}</span>
              </NavLink>
            ))}
          </nav>
        </aside>
        <main className="col-span-12 md:col-span-9">
          <Outlet />
        </main>
      </div>
    </div>
  );
}
